import { Injectable } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

function _window():any{
	return window;
}

@Injectable({
  providedIn: 'root'
})
export class DeviceInfoService {

	window = null;
  constructor(private deviceService: DeviceDetectorService) { 
  	this.window = _window();
  }

  isIos():boolean{
    return /iphone|ipad|ipod/.test(this.window.navigator.userAgent.toLowerCase());  
  }
  isIPhone(){
    return /iphone/.test(this.window.navigator.userAgent.toLowerCase());  
  }
  isIPad(){
    return /ipad/.test(this.window.navigator.userAgent.toLowerCase());  
  }
  isIPod(){
    return /ipod/.test(this.window.navigator.userAgent.toLowerCase());  
  }


  isDesktop():boolean{
  	return this.deviceService.isDesktop();
  }
  isTablet():boolean{
  	return this.deviceService.isTablet();
  }
  isMobile():boolean{
	return this.deviceService.isMobile();
  }

  get browser():string{
  	return this.deviceService.browser;
  }

  get browser_version():string{
  	return this.deviceService.browser_version;
  }

  get ua():string{
  	return this.deviceService.ua;
  }
  
  get userAgent():string{
  	return this.deviceService.userAgent;
  }


  get device():string{
  	return this.deviceService.device;
  }

  get os():string{
  	return this.deviceService.os;
  }

  get os_version():string{
  	return this.deviceService.os_version;
  }

  getDeviceInfo():any{
  	return this.deviceService.getDeviceInfo();

  }
}
